<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <router-link :to="computedLink">
        <span v-on="on">{{computedFormatted}}</span>
      </router-link>
    </template>
    <span>{{computedFull}}</span>
  </v-tooltip>
</template>

<script>
import { nameFormatted } from "@/util/helpers";
export default {
  name: "HolidayEntity",
  props: ["entity", "format", "year", "holidayId"],
  computed: {
    computedFormat() {
      return this.format ? this.format : "initials";
    },
    computedFormatted() {
      if (this.entity) {
        return nameFormatted(this.entity.name, this.computedFormat);
      } else {
        return this.computedFormat == "initials" ? "Pub." : "Public Holiday";
      }
    },
    computedFull() {
      return this.entity
        ? nameFormatted(this.entity.name, "full")
        : "Public Holiday";
    },
    computedLink() {
      return this.entity
        ? {
            name: "holidayEntity",
            params: { id: this.entity.id },
            query: { year: this.year, holidayId: this.holidayId }
          }
        : {
            name: "holidayEntityPublicHoliday",
            query: { year: this.year, holidayId: this.holidayId }
          };
    }
  },
  methods: {
    nameFormatted
  }
};
</script>
